import React, { memo, type PropsWithChildren } from 'react';
import isEqual from 'react-fast-compare';
import { Box } from '../../../../../Box';
import { dataTableClassnames } from '../../../const/classNames';

interface CellWrapperProps {
  fieldName: string;
  className: string;
  width: number;
  style: React.CSSProperties;
}

export const CellWrapper: React.FC<PropsWithChildren<CellWrapperProps>> = memo(
  ({ fieldName, className, width, children, style }) => {
    return (
      <Box
        className={`${dataTableClassnames.table.cell.root} ${dataTableClassnames.table.cell.body} ${className}`}
        data-field={fieldName}
        style={{
          ...style,
          width
        }}
        role="gridcell"
      >
        {children}
      </Box>
    );
  },
  (prevProps, nextProps) => {
    const { children: _cp, ...prev } = prevProps;
    const { children: _cn, ...next } = nextProps;
    const childrenLvl0 = isEqual((_cp ?? ({} as any)).props, (_cn ?? ({} as any)).props);
    return isEqual(prev, next) && childrenLvl0;
  }
);
